import { Box, MenuItem } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import {
  CustomButton,
  CustomSelect,
  CustomTextField,
  HorizontalForm,
} from '../../../common/components';
import {
  DEBT_STATUS_ORDER_OPTIONS,
  DEBT_STATUS_OPTIONS,
  DEBT_STATUS_POSSESSOR_OPTIONS,
} from '../constants/debtStatusConstants';

const DebtStatusFilters = ({
  filters,
  paymentMethods,
  paymentMethodsLoading,
  loading,
  onFilterChange,
  onApplyFilters,
}) => (
  <HorizontalForm variant="twoRows">
    <Box>
      <CustomSelect
        label="Poseedor"
        name="possessor"
        size="medium"
        value={filters.possessor}
        onChange={onFilterChange}
        sx={{ maxWidth: 180, mr: 1.5 }}
      >
        {DEBT_STATUS_POSSESSOR_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomSelect
        label="Orden"
        name="orderBy"
        size="medium"
        value={filters.orderBy}
        onChange={onFilterChange}
        sx={{ maxWidth: 220, mr: 1.5 }}
      >
        {DEBT_STATUS_ORDER_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomTextField
        label="Num. Contrato"
        name="contractNumber"
        value={filters.contractNumber}
        onChange={onFilterChange}
        sx={{ maxWidth: 140, mr: 1.5 }}
      />

      <CustomSelect
        label="Forma de pago"
        name="paymentMethod"
        size="medium"
        value={filters.paymentMethod}
        onChange={onFilterChange}
        sx={{ maxWidth: 220 }}
        disabled={paymentMethodsLoading}
      >
        <MenuItem value="">Todas</MenuItem>
        {paymentMethods.map((method) => (
          <MenuItem key={method.uuid} value={method.uuid}>
            {method.name}
          </MenuItem>
        ))}
      </CustomSelect>
    </Box>
    <Box>
      <CustomTextField
        label="Cupones desde"
        type="number"
        name="minOverdueCoupons"
        value={filters.minOverdueCoupons}
        onChange={onFilterChange}
        inputProps={{ min: 0 }}
        sx={{ maxWidth: 140, mr: 1.5 }}
      />
      <CustomTextField
        label="Cupones hasta"
        type="number"
        name="maxOverdueCoupons"
        value={filters.maxOverdueCoupons}
        onChange={onFilterChange}
        inputProps={{ min: 0 }}
        sx={{ maxWidth: 140, mr: 1.5 }}
      />
      <CustomSelect
        label="Estado"
        name="debtStatus"
        size="medium"
        value={filters.debtStatus}
        onChange={onFilterChange}
        sx={{ maxWidth: 260, mr: 1.5 }}
      >
        <MenuItem value="">Todos</MenuItem>
        {DEBT_STATUS_OPTIONS.map((status) => (
          <MenuItem key={status} value={status}>
            {status}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomButton
        variant="base"
        startIcon={<Refresh />}
        onClick={onApplyFilters}
        disabled={loading}
        sx={{ mt: 1.5 }}
      >
        Aplicar filtros
      </CustomButton>
    </Box>
  </HorizontalForm>
);

export default DebtStatusFilters;
